import React, { useEffect, useMemo, useState } from "react";
import { Tabs } from "antd";
import { VehicleVersionTable } from "../VehicleVersionTable";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { AppRowCar, buildViewRowsCar, kCity, kRole, makeColumnsCar } from "../VehicleVersionTable/fn";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import { FieldsUpdate, getListCustomerInteractions, getListFieldsByCustomer, getListVehicleInterestContactHistory, ICustomer, IVehicleInterestContactHistory, ListField, updateFieldUser } from "../../../../api/Customer_V2/customerApi_V2";
import CarFeilds from "./CarFeilds";
import { SettingOutlined } from "@ant-design/icons";
import ContactHistory from "../ServiceRecords/ContactHistory";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import useDebounce from "../../../../hook/useDebounce";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { useSelector } from "react-redux";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import { PaginationProps } from "antd/lib";
import ServiceRecordFeilds from "../ServiceRecords/Components/ServiceRecordFeilds";
import { FIELDTYPE } from "../../../../services/data";
import { flattenFields, getUserPermissions } from "../../../../until";
import useThrottle from "../../../../hook/useThrottle";
import { selectorPermission } from "../../../../store/slices/permissionSlice";
interface IDataFilterActive {
  contactHistory: FlattenedField[];
}

interface IDataFilterNoActive {
  contactHistory: ListField[];
}

const EMPTY_GROUP = {
  contactHistory: [],
};

type PaginationKey = "contactHistory";

interface Props {
  loadingTable?: boolean
  dataFilterActive: FlattenedField[]

  idCustomer?: number
  listVehicle: ICustomer[]
}
const InterestedCar: React.FC<Props> = ({
  loadingTable, dataFilterActive,
  idCustomer, listVehicle
}) => {

  const pushLoading = useLoading()
  const pushToast = useToast();
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const { id, unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const permissionSlice = useSelector(selectorPermission)
  const { access, edit } = getUserPermissions(permissionSlice, location.pathname)
  useEffect(() => {
    gListFieldsActive()
  }, [])

  const [isSettingShow, setSettingShow] = useState(false)

  const [loadingTableDetail, setLoadingTableDetail] = useState(false)

  const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState<PaginationKey>("contactHistory");
  const [dataFieldsServiceRecordsActive, setDataFieldsServiceRecordsActive] = useState<IDataFilterActive>(EMPTY_GROUP);
  const [dataFieldsServiceRecordsNoActive, setDataFieldsServiceRecordsNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

  const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
    contactHistory: { current: 1, pageSize: 10, total: 0 },
  });
  const [loadedTabs, setLoadedTabs] = useState({
    contactHistory: false,
  });

  const [dmsId, setDmsId] = useState<string>();
  const [selectedId, setSelectedId] = useState<number>();
  const [contactHistory, setContactHistory] = useState<IVehicleInterestContactHistory>();

  // #region Modal
  const handleOpenModal = (type: string, id: number) => {
    // console.log(type, id)
  }

  //#endregion


  //#region Cấu hình VehicleVersionTable
  const filterColumn = ['nameCar', 'year', 'price'];
  // expanded set
  const [expanded, setExpanded] = React.useState<Set<string>>(new Set());

  // Build rows từ dataCarTest
  const viewRowsCar = useMemo(() =>
    buildViewRowsCar(listVehicle, expanded),
    [expanded, listVehicle]);


  // Toggle expand
  const toggleCarType = React.useCallback((carType: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      const key = kCity(carType);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  }, []);

  const toggleBrand = React.useCallback((carType: string, brand: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      const key = kRole(carType, brand);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  }, []);

  // Columns (tĩnh + động)
  const columnsCar = useMemo(
    () => makeColumnsCar(
      expanded, access, false, toggleCarType, toggleBrand, dataFilterActive, handleOpenModal, idCustomer, undefined,
      permittedCategoryCarIds

    ),
    [expanded, toggleCarType, toggleBrand, columnsMapShow, permittedCategoryCarIds]
  );

  // Đồng bộ columnsMapShow từ cấu hình active
  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode) as ColumnKey[];
    setColumnsMapShow(codes);
  }, [dataFilterActive]);
  //#endregion



  const gListFieldsActive = async () => {
    const [vehicleInvoiceRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.contactHistoryByInterestedCar, 1),
      ]);

    const flattenedFieldsVehicleInvoice = flattenFields(vehicleInvoiceRes?.data ?? []);

    setDataFieldsServiceRecordsActive({
      contactHistory: flattenedFieldsVehicleInvoice,
    });

    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    const [vehicleInvoiceNoActiveRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.contactHistoryByInterestedCar, 0),
      ]);
    setDataFieldsServiceRecordsNoActive({
      contactHistory: vehicleInvoiceNoActiveRes?.data ?? [],
    });
  };

  const gListContactHistory = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    if (!idCustomer || !dmsId || !selectedId) {
      setContactHistory(undefined)
      return;
    }
    setLoadingTableDetail(true)
    const result = await getListVehicleInterestContactHistory(
      selectedId, idCustomer, dmsId, unitTemp, permittedCategoryCarIds,
      pageSize, pageCurent
    )
    if (result?.status) {
      setContactHistory(result.data)
      setPaginationMap(prev => ({
        ...prev,
        contactHistory: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      contactHistory: true,
    }));
    setLoadingTableDetail(false)
  }, 1000)



  const onRowClickVehicleVersionTable = (row: AppRowCar, rowIndex: number) => {
    if (!row || !row.dmsId || !row.id) {
      setDmsId(undefined);
      setSelectedId(undefined);
      return;
    }

    // const [rowId] = String(row.idCover).split("-");
    console.log(row, idCustomer)
    // const isNumeric = /^[0-9]+$/.test(rowId);
    setSelectedId(row.idCover ? Number(row.idCover) : 0);

    setDmsId(row.dmsId);
  }


  const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
    let result: any;
    const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));
    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );
    const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

    switch (activeServiceRecordsTab) {

      case 'contactHistory': {
        result = await updateFieldUser(id, FIELDTYPE.contactHistoryByInterestedCar, undefined, listActiveFields)
        break;
      }

      default:
        break;
    }

    if (result?.status) {
      pushToast(result?.message, "success")
      setSettingShow(false)

      if (dataFilterActive && dataFilterNoActive) {
        setDataFieldsServiceRecordsActive(prev => ({
          ...prev,
          [activeServiceRecordsTab]: dataFilterActive ?? [],
        }));

        setDataFieldsServiceRecordsNoActive(prev => ({
          ...prev,
          [activeServiceRecordsTab]: dataFilterNoActive ?? [],
        }));
      }

    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)


  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    switch (activeServiceRecordsTab) {
      case "contactHistory": {
        gListContactHistory(pageNumber, pageSize)
        break;
      }
      default:
        break;
    }
  }


  useEffect(() => {
    if (!dmsId || !selectedId) return;

    // console.log("CHANGE VEHICLE:", selectedVehicleId, "TAB:", activeServiceRecordsTab);

    // 1️⃣ RESET
    setContactHistory(undefined);

    setLoadedTabs({

      contactHistory: false,
    });

    setPaginationMap({
      contactHistory: { current: 1, pageSize: 10, total: 0 },
    });

    // 2️⃣ GỌI API ĐÚNG TAB
    switch (activeServiceRecordsTab) {

      case "contactHistory":
        gListContactHistory();
        break;
      default:
        break;
    }
  }, [selectedId, dmsId]);

  useEffect(() => {
    console.log(selectedId)
    if (typeof (selectedId) !== "number") return
    if (!dmsId)
      return pushToast("Không có thông tin chi tiết để hiển thị!", "warning");;

    switch (activeServiceRecordsTab) {


      case "contactHistory":
        console.log(2)
        if (!loadedTabs.contactHistory) gListContactHistory();
        break;
      default:
        break;
    }
  }, [activeServiceRecordsTab, selectedId]);

  useEffect(() => {

    if (idCustomer) {
      setDmsId(undefined)

      setContactHistory(undefined)
    }
  }, [idCustomer])

  return (
    <>

      {
        isSettingShow ?
          <ServiceRecordFeilds
            isSettingShow={isSettingShow}
            recordId={1}
            type={0}
            dataFilterActive={dataFieldsServiceRecordsActive[activeServiceRecordsTab]}
            dataFilterNoActive={dataFieldsServiceRecordsNoActive[activeServiceRecordsTab]}

            // onSaveDataFields={onSaveDataFields}
            onSaveVisibleFields={onSaveVisibleFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      }
      <div
        className="custom-page-css border rounded "
        style={{ width: "100%" }}
      >
        <VehicleVersionTable<any>
          loadingTable={loadingTable}
          nonDraggableColumnIds={["action"]}
          nonResizableColumnIds={["action"]}
          columns={columnsCar}
          filterColumn={filterColumn}
          rows={viewRowsCar}
          rowClassName={(row) =>
            (row.data.kind === "group-city" || row.data.kind === "group-role") ? "row-group" : ""
          }
          onRowClick={onRowClickVehicleVersionTable}
        />
      </div>
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs relative"
        style={{ width: "100%", marginTop: "16px" }}
      // hidden={!selectedVehicleId}
      >
        <Tabs
          activeKey={activeServiceRecordsTab}
          items={[
            {
              key: "contactHistory",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Lịch sử tiếp xúc
                </span>
              ),
              children: (
                <ContactHistory
                  loadingTableDetail={loadingTableDetail}
                  dataFieldsActive={dataFieldsServiceRecordsActive.contactHistory}
                  pagination={paginationMap.contactHistory}
                  data={contactHistory}

                  onPaginationChange={onPaginationChange}
                />

              ),
            }
          ]}
          onChange={(k) => setActiveServiceRecordsTab(k as PaginationKey)}
        />
        <div className="custom-page-css absolute top-4 right-2">
          <div className='settingCol'>
            <div className='ctr-col-setting'
              onClick={() => setSettingShow(true)}
            >
              <SettingOutlined />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterestedCar;
